<app-header></app-header>
<div class="min-h-screen flex justify-center items-center px-4 sm:px-6 py-6 sm:py-8 bg-cover bg-center">
    <div class="flex justify-center w-full max-w-md sm:max-w-lg md:max-w-xl">
        <div class="flex flex-col bg-white p-5 sm:p-7 md:p-9 w-full rounded-lg shadow-lg">
            <div class="flex justify-center mb-6 sm:mb-8 md:mb-10">
                <img src="assets/images/pruforce-corporate.png" class="h-16 sm:h-20 md:h-24" alt="Pruforce Corporate Logo" />
            </div>

            <div *ngIf="errorMessage"
                class="text-center p-3 sm:p-4 mb-3 sm:mb-4 text-xs sm:text-sm font-medium text-red-800 rounded-lg bg-red-100">
                {{ errorMessage }}
            </div>

            <div class="w-full">
                <div class="mb-3 sm:mb-4">
                    <div class="mb-1">
                        <input class="shadow-sm w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-full focus:outline-none"
                            [(ngModel)]="username" [placeholder]="'SALESFORCE.LOGIN.USERNAME' | translate"
                            (blur)="validateUsername()" />
                    </div>
                    <div *ngIf="usernameTouched && !username" class="text-red-500 text-xs sm:text-sm pl-4 mb-3">
                        {{ 'SALESFORCE.LOGIN.USERNAME_REQUIRED' | translate }}
                    </div>
                </div>
                <div class="mb-4 sm:mb-6">
                    <div class="mb-1">
                        <app-password-input
                            [(ngModel)]="password"
                            [placeholder]="'SALESFORCE.LOGIN.PASSWORD' | translate"
                            [disabled]="loading"
                            [customClass]="'shadow-sm w-full px-3 sm:px-4 py-2.5 sm:py-3 pr-12 text-base border rounded-full focus:outline-none'"
                            (blur)="validatePassword()">
                        </app-password-input>
                    </div>
                    <div *ngIf="passwordTouched && !password" class="text-red-500 text-xs sm:text-sm pl-4 mb-3">
                        {{ 'SALESFORCE.LOGIN.PASSWORD_REQUIRED' | translate }}
                    </div>
                </div>

                <button (click)="login()" [disabled]="!isFormValid() || loading"
                    class="w-full rounded-full text-white py-2.5 sm:py-3 text-base sm:text-lg font-medium min-h-[48px]"
                    [ngClass]="{ 'opacity-50 cursor-default bg-gray-800': !isFormValid() || loading, 'hover:bg-red-700 bg-red-600': isFormValid() && !loading }">
                    <span *ngIf="!loading">{{ 'SALESFORCE.LOGIN.LOGIN_BUTTON' | translate }}</span>
                    <span *ngIf="loading" class="flex items-center justify-center">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                        {{ 'SALESFORCE.LOGIN.LOGGING_IN' | translate }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
